import type {
  IAvailabilityOptionDtoData,
} from '../../../dtos/ProdegaApiWebshop-api-typings-generated';
import { cartActorRef } from '../CartProvider';
import { logCartEvent } from '../cartMachineLogger';
import { api } from '../state-machine/backend-access/api';
import type { CartEventTypes } from '../state-machine/events';
import type { SendCartUserData } from '../state-machine/types';
import { logToConsole } from '../../../logging/consoleLogger';

const loggerName = 'use-cart';
function logError(message: string, ...args: any[]) {
  logToConsole({ loggerName, logLevel: 'ERROR', message, args });
}

export function loginCart() {
  if (cartActorRef) {
    if (cartActorRef.getSnapshot().value === 'NotLoggedIn') {
      sendToCart({
        type: 'login'
      });
    }
  } else {
    logError('Cart state machine not initialized! Login not possible.');
  }
}

export function logoutCart() {
  if (cartActorRef) {
    if (cartActorRef.getSnapshot().value !== 'NotLoggedIn') {
      sendToCart({
        type: 'logout'
      });
    }
  } else {
    logError('Cart state machine not initialized! Login not possible.');
  }
}

export function addPositionToCart(
  articleNumber: string,
  quantity: number,
  externalArticle: boolean,
  articleDescriptionForErrorMessage: string
) {
  sendToCart({
    type: 'addPositionIntent',
    value: { operation: 'ADD', articleNumber, quantity, externalArticle, articleDescriptionForErrorMessage }
  });
}

export function copyExistingOrderToCart(existingOrderId: number) {
  sendToCart({
    type: 'addPositionIntent',
    value: { operation: 'COPY_EXISTING_ORDER_TO_CART', existingOrderId }
  });
}
export function copyTemplateArticleToCart(templateId: number, selectedMainArticleIds?: number[]) {
  sendToCart({
    type: 'addPositionIntent',
    value: { operation: 'COPY_TEMPLATE_ARTICLE_TO_CART', templateId, selectedMainArticleIds }
  });
}
export function copySalesOrderSetArticleToCart(articles: { articleNumber: string; quantity: number }[]) {
  sendToCart({
    type: 'addPositionIntent',
    value: { operation: 'COPY_SALESORDERSET_TO_CART', articles }
  });
}

export function importCsvToCart(csvText: string) {
  sendToCart({
    type: 'addPositionIntent',
    value: { operation: 'IMPORT_CSV_TO_CART', csvText }
  });
}

export function addPositionsToCart(
  positions: {
    articleNumber: string;
    quantity: number;
    externalArticle: boolean;
    articleDescriptionForErrorMessage: string;
  }[]
) {
  for (const position of positions) {
    addPositionToCart(
      position.articleNumber,
      position.quantity,
      position.externalArticle,
      position.articleDescriptionForErrorMessage
    );
  }
}

export function cancelCart() {
  sendToCart({
    type: 'cancelCart'
  });
}

export function sendCart(sendCartParams: SendCartUserData) {
  sendToCart({
    type: 'sendCart',
    sendCartParams
  });
}

export function changeDeliveryDateOfCart() {
  sendToCart({
    type: 'changeDeliveryDateOfCart'
  });
}

export function abortUserInputForCart() {
  sendToCart({
    type: 'abortUserInputForCart'
  });
}

export function reloadShoppingCart() {
  sendToCart({
    type: 'reloadShoppingCart'
  });
}

export function refreshShoppingCart() {
  sendToCart({
    type: 'refreshShoppingCart'
  });
}

export function chooseDeliveryDate(deliveryDate: string) {
  sendToCart({
    type: 'chooseDeliveryDate',
    desiredDeliveryDate: deliveryDate
  });
}

export function userOptionSelected(selectedUserDialogOption: IAvailabilityOptionDtoData[]) {
  sendToCart({
    type: 'userOptionSelected',
    selectedUserDialogOption
  });
}

export function acknowledgeBlockedPositionsDialog() {
  sendToCart({
    type: 'acknowledgeBlockedPositionsDialog'
  });
}

export function resetBlockedPositionsAcknowledge() {
  sendToCart({
    type: 'resetBlockedPositionsAcknowledge'
  });
}


export function sendToCart(event: typeof CartEventTypes) {
  if (!cartActorRef || !api()) {
    logError('Cart state machine not initialized! Sending event not possible:', event);
    return;
  }
  const snap = cartActorRef.getSnapshot?.();
  if (snap?.status !== 'active') {
    logError('Cart state machine not active! Sending event not possible:', event);
    // 2025-11-03, Jonas: Dies sollte nie passieren ...
    // aber wenn es doch passiert, ist es besser, die Seite neu zu laden, als dass der Shopping Cart "nicht funktioniert" ...
    window.location.reload();
    return;
  }
  logCartEvent(event);
  cartActorRef.send(event);
}
